module.exports = __webpack_public_path__ + "img/Flag_of_the_Dominican_Republic.9ab3bcb7.svg";